export enum SubjectType {
    BrandCompany = 1,
    MarketCompany = 2,
    Customer = 3,
    Company = 4,
    ThirdPartyLogistics = 5,
    ProductionSite = 6,
}
